import { render, staticRenderFns } from "./GImage.vue?vue&type=template&id=1f80906a&scoped=true"
import script from "./GImage.vue?vue&type=script&lang=js"
export * from "./GImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80906a",
  null
  
)

export default component.exports